/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * BellOffIcon
 */
export default class BellOffIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M1.613.21l.094.083 22 22a1 1 0 01-1.32 1.497l-.094-.083L17.584 19 3 19c-.273 0-.492-.041-.719-.255l-.098-.103c-.432-.497-.296-.978-.008-1.33.11-.134.199-.203.4-.345.008-.004.275-.189.362-.25.147-.105.274-.2.392-.298.449-.372.671-.698.671-.919V8c0-.674.223-1.321.646-1.937L.293 1.707A1 1 0 011.613.21zM11 19a1 1 0 001.993.117L13 19h2a3 3 0 01-5.995.176L9 19h2zm4.584-2.001L6.108 7.523A1.188 1.188 0 006 8v7.5c0 .554-.175 1.046-.487 1.5l10.071-.001zM12 2c3.706 0 7.828 3.083 7.995 5.829L20 8v5a1 1 0 01-1.993.117L18 13V8c0-1.546-3.22-4-6-4-.844 0-1.739.21-2.61.598a1 1 0 11-.815-1.826C9.692 2.273 10.86 2 12 2z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

